import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from "react-bootstrap";

import BudgetItemFormTable from "./BudgetItemFormTable";
import { CancelButton } from "../../elements/ActionButtons/CancelButton";
import ClientProjectSelect from "../ClientProject/ClientProjectSelect";
import ProjectSelect from "../Project/ProjectSelect";
import { DeleteButton } from "../../elements/ActionButtons/DeleteButton";
import Queries from "../../queries/queries2";
import { Query } from "react-apollo";
import React, { Fragment } from "react";
import { SaveButton } from "../../elements/ActionButtons";
import Spinner from "../../elements/Spinner/Spinner";
import TierSelect from "../Tier/TierSelect";
import { compose } from "recompose";
import { injectIntl, FormattedMessage } from "react-intl";

import Switch from "react-bootstrap-switch";

import CustomButton from "../../elements/CustomButton/CustomButton";

class BudgetCategoryItemForm extends React.Component {
  constructor(props) {
    super(props);

    // form state
    this.state = {
      ...props.values,
      deleteButtonText: "ids_delete",
      errors: {}
    };
  }

  validate = () => {
    const errors = {
      yearError: !!!this.state.year ? "error" : null
      // monthError: !!!this.state.month ? "error" : null
    };
    this.setState({ errors });

    return !!!errors.yearError;
    // && !!!errors.monthError;
  };

  updateBudgetItemTable = tableData => {
    // console.log("updateBudgetitem", tableData);
    if (this.state.originalItemsData === undefined) {
      const data = JSON.stringify(tableData);
      this.setState({ items: tableData, originalItemsData: data });
    }
    else {
      this.setState({ items: tableData });
    }
  };

  updateBudgetIsReal = (isReal, reset) => {

    // console.log("63 - reset=", reset);
    if (this.state.originalIsRealData === undefined || reset === true) {
      this.setState({ isReal: isReal, originalIsRealData: isReal });
    }
    else {
      this.setState({ isReal: isReal });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    // const variables = {
    //   companyId: this.state.companyId,
    //   tiersId: this.state.tiersId
    // };
    // const res = await this.props.getBudgetItems.refetch(variables);    
  };

  static getDerivedStateFromProps = async (props, state) => {

    // console.log("82 - getDerivedStateFromProps", props, state);
    if (props.values && props.values.previousNextCommand && (
      props.values.categoryId !== state.categoryId ||
      props.values.projectId !== state.projectId ||
      props.values.tiersClientId !== state.tiersClientId ||
      props.values.tiersId !== state.tiersId ||
      props.values.isReal !== state.isReal ||
      // props.values.isChiffreDAffaires !== state.isChiffreDAffaires
      props.values.showSupplier !== state.showSupplier ||
      props.values.showClient !== state.showClient
    )) {
      // console.log("83 -+++");
      state.categoryId = props.values.categoryId;
      state.projectId = props.values.projectId;
      state.tiersClientId = props.values.tiersClientId;
      state.tiersId = props.values.tiersId;
      state.isReal = props.values.isReal;
      // state.isChiffreDAffaires = props.values.isChiffreDAffaires;
      state.showSupplier = props.values.showSupplier;
      state.showClient = props.values.showClient;

      state.originalItemsData = undefined;
      state.originalIsRealData = undefined;
      props.setPreviousNextCommand(false);
    }
    // console.log("62 - getDerivedStateFromProps", state);
  };


  render = () => {
    const {
      intl,
      sendNotification,
      cancel,
      save,
      workInProgress,
      deleteBudgetItems,
      // goPreviousBudget,
      // goNextBudget,
      currencyId,
      companyId,
      role
      // companyDefaultInfos
      // disabled
    } = this.props;

    // console.log("112 - state=", this.state);
    const { categoryId, tiersId, projectId, tiersClientId, year, isReal } = this.state;

    let saveDisable = true;
    if ( this.state.originalIsRealData === undefined ) {
      // console.log("126 - this.state=", this.state);
      this.state.originalIsRealData = this.state.isReal;
    } 
    
    if (this.state.originalItemsData && this.state.originalIsRealData !== undefined) {
      if (
        this.state.originalItemsData !== JSON.stringify(this.state.items) ||
        this.state.originalIsRealData !== this.state.isReal
      ) {
        saveDisable = false;
      }
    }
    this.props.setShowAlertPreviousNext(!!!saveDisable);

    // console.log("130 - P=", this.props);
    // console.log("131 - S=", this.state);

    const disabled = false;
    return (
      <React.Fragment>
        <Row md={12}>
          <Col xs={1}>
            <ControlLabel>
              {intl.formatMessage({ id: "ids_year" })}
            </ControlLabel>
          </Col>
          <Col xs={2}>
            <FormGroup validationState={this.state.errors.yearError}>
              <FormControl
                disabled={!!disabled}
                name="year"
                type="number"
                value={year}
                onChange={event =>
                  event.target.value &&
                  this.setState({
                    year: parseInt(event.target.value),
                    originalItemsData: undefined,
                    originalIsRealData: undefined
                  })
                }
              />
            </FormGroup>
          </Col>
          {/* <React.Fragment> */}
          <Col xs={1}>
            <ControlLabel>
              {intl.formatMessage({ id: "ids_tiers" })}
            </ControlLabel>
          </Col>
          <Col xs={3}>
            <FormGroup validationState={this.state.errors.yearError}>
              <TierSelect
                isClearable={true}
                sendNotification={sendNotification}
                companyDefaultInfos={null /*companyDefaultInfos*/}
                disabled={false}
                companyId={companyId}
                value={tiersId}
                showEdit={false}
                
                // showSuppliers={!!!this.state.isChiffreDAffaires}
                // showCollaborators={!!!this.state.isChiffreDAffaires}
                // showClients={!!this.state.isChiffreDAffaires}
                // showComptables={!!!this.state.isChiffreDAffaires}
                showSuppliers={!!this.state.showSupplier}
                showCollaborators={!!this.state.showSupplier}
                showClients={!!this.state.showClient}
                showComptables={!!this.state.showSupplier}

                error={null}
                onSelected={e => {
                  console.log("event", e);
                  if (e) {
                    this.setState({
                      tiersId: e.value,
                      originalItemsData: undefined,
                      originalIsRealData: undefined
                    });
                  } else {
                    // reset field
                    this.setState({
                      tiersId: null,
                      originalItemsData: undefined,
                      originalIsRealData: undefined
                    });
                  }
                  //   event.target.value &&
                  //     this.setState({ tiersId: event.target.value });
                }}
              />
            </FormGroup>
          </Col>

          {!!this.state.showSupplier ? (
            <div>
              <Col xs={2}>
                <ControlLabel>
                  {intl.formatMessage({ id: "ids_clientOrProject" })}
                </ControlLabel>
              </Col>
              <Col xs={3}>
                <ClientProjectSelect
                  companyId={companyId}
                  filter={{}}
                  value={tiersClientId ? tiersClientId : projectId}
                  role={role}
                  onSelected={e => {
                    // console.log("163 - e", e);
                    if (e) {
                      this.setState({
                        tiersClientId: e.type === "client" ? e.value : null,
                        projectId: e.type !== "client" ? e.value : null,
                        originalItemsData: undefined,
                        originalIsRealData: undefined
                      });
                    } else {
                      //reset state to null
                      this.setState({
                        tiersClientId: null, projectId: null,
                        originalItemsData: undefined,
                        originalIsRealData: undefined
                      });
                    }
                  }}
                />
              </Col>
            </div>
          ) : (
              <div>
                <Col xs={1}>
                  <ControlLabel>
                    {intl.formatMessage({ id: "ids_project" })}
                  </ControlLabel>
                </Col>
                <Col xs={3}>
                  <ProjectSelect
                    companyId={companyId}
                    filter={{}}
                    value={projectId || ""}
                    creatable={role==="ADMIN"}
                    onSelected={e => {
                      this.setState({ projectId: e && e.value });
                    }}
                  />
                </Col>
              </div>
            )}
        </Row>

        {/* </React.Fragment> */}
        {/* <React.Fragment>
          <Col xs={2}>
            <ControlLabel>
              {intl.formatMessage({ id: "ids_project" })}
            </ControlLabel>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <ProjectSelect
                disabled={!!disabled}
                sendNotification={sendNotification}
                companyId={companyId}
                value={projectId || ""}
                onSelected={e => {
                  this.setState({ projectId: e && e.value });
                }}
                creatable
              />
            </FormGroup>
          </Col>
        </React.Fragment> */}
        <Row>
          <Col xs={12}>
            <Query
              query={Queries.getBudgetCategoryItemsByYear}
              fetchPolicy="network-only"
              // fetchPolicy="cache-and-network"
              variables={{
                companyId,
                tiersId,
                year,
                projectId,
                categoryId,
                tiersClientId
              }}
            >
              {({
                loading,
                error,
                data: { getBudgetCategoryItemsByYear },
                fetchMore,
                subscribeToMore,
                refetch
              }) => {
                console.log("Query getBudgetCategoryItemsByYear");
                if (loading) return <Spinner size="lg" fullScreen />;
                if (error) return `Error! ${error.message}`;
                return (
                  <BudgetItemFormTable
                    companyId={companyId}
                    categoryId={categoryId}
                    currencyId={currencyId}
                    tiersId={tiersId}
                    year={year}
                    projectId={projectId || ""}
                    updateBudgetItemTable={this.updateBudgetItemTable}
                    updateBudgetIsReal={this.updateBudgetIsReal}
                    data={getBudgetCategoryItemsByYear}
                    globalIsReal={isReal}
                    budgetType={"Category"}
                  />
                );
              }}
            </Query>
          </Col>

          <Col xs={5}>
            <div className="side-modal-footer">

              <Fragment>
                <span style={{ marginRight: "12px" }}>
                  <FormattedMessage id="ids_situation" />
                  <FormattedMessage id="ids_colon" />{" "}
                </span>
                <span style={{ marginRight: "12px" }}>
                  <FormattedMessage id="ids_real" />
                </span>
                <Switch
                  onText=""
                  offText=""
                  value={!isReal}  // this.state.isReal}
                  onChange={e => {
                    console.log("onchange...", e);
                    const value = !e.state.value;
                    this.setState({ isReal: value });
                  }}
                />
                <span style={{ marginRight: "240px", marginLeft: "12px" }}>
                  <FormattedMessage id="ids_budget" />
                </span>
              </Fragment>

              <DeleteButton
                wd
                className="pull-right"
                disabled={workInProgress}
                // margin-left-20
                ids={this.state.deleteButtonText}
                onClick={() => {
                  if (this.state.deleteButtonText === "ids_delete") {
                    this.setState({ deleteButtonText: "ids_confirm" });
                  }
                  else if (this.state.deleteButtonText === "ids_confirm") {
                    this.setState({ deleteButtonText: "ids_delete" });
                    return deleteBudgetItems(this.state);
                  }                  
                }}
              />
              {/* <CancelButton wd onClick={cancel} /> */}
              <SaveButton
                disabled={saveDisable}
                workInProgress={!!workInProgress}
                className="btn-fill pull-right"
                onClick={() => {
                  if (this.validate()) {
                    const data = JSON.stringify(this.state.items);
                    this.setState({ originalItemsData: data, originalIsRealData: this.state.isReal });
                    save(this.state);
                  }
                }}
              />

            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };
}

export default compose(injectIntl)(BudgetCategoryItemForm);
